export const publisherPlatforms = [
  'facebook',
  'instagram',
  'messenger',
  'audience_network',
] as const;
export type PublisherPlatform = typeof publisherPlatforms[number];
